import { cn } from '@jem-open/jem-ui';
import { Check } from 'lucide-react';
import { Step } from './constants';

const STEP_ITEMS = [
  { key: Step.SelectEmployer, label: 'Select Employer' },
  { key: Step.Upload, label: 'Upload CSV' },
  { key: Step.Review, label: 'Review Upload' },
  { key: Step.Submitting, label: 'Create Users' },
] as const;

interface StepIndicatorProps {
  currentStep: Step;
}

const stepIndex = (step: Step): number =>
  STEP_ITEMS.findIndex((s) => s.key === step);

const StepIndicator = ({ currentStep }: StepIndicatorProps) => {
  const currentIndex = stepIndex(currentStep);

  return (
    <nav aria-label="Bulk upload progress" className="flex items-start justify-center my-5">
      {STEP_ITEMS.map((s, i) => {
        const isCompleted = i < currentIndex;
        const isActive = i === currentIndex;

        const stepTextClass = cn('text-xs', {
          'font-semibold text-greyscale-text-title': isActive,
          'font-medium text-greyscale-text-body': isCompleted && !isActive,
          'text-greyscale-text-caption': !isActive && !isCompleted,
        });

        return (
          <div key={s.key} className="flex items-center">
            <div className="flex flex-col items-center gap-xxs">
              <div
                className={cn(
                  'flex items-center justify-center size-[28px] rounded-full text-xs font-semibold shrink-0',
                  isCompleted || isActive
                    ? 'bg-secondary-surface text-neutral-white'
                    : 'bg-neutral-white text-greyscale-text-caption',
                )}
              >
                {isCompleted ? <Check className="size-[14px]" /> : i + 1}
              </div>
              <span className={cn('whitespace-nowrap', stepTextClass)}>
                {s.label}
              </span>
            </div>
            {i < STEP_ITEMS.length - 1 && (
              <div
                className={cn(
                  'h-px mx-xs rounded-full w-24 self-start mt-[14px]', /* half of circle size */
                  isCompleted
                    ? 'bg-secondary-surface'
                    : 'bg-greyscale-border',
                )}
              />
            )}
          </div>
        );
      })}
    </nav>
  );
};

export default StepIndicator;
